export default "__VITE_ASSET__9LI0lyNU__"